/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/spatioport_orbital': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M18 12V9c0-3-1-5-3-5s-3 2-3 5v3l3-6 3 6zM18 22v2h-6v-2h6zM13 24.5h4V26h-4zM5 27h22v1H5zM13 20l2-4 2 4z"/><path pid="1" d="M18 20l-3-6-3 6h-2l5.007-10L20 20zM11 11s0-3-1.5-3S8 11 8 11v9l3-6v-3zM22 11s0-3-1.5-3-1.5 3-1.5 3v2.993L22 20v-9zM8 22h3v3H8zM19 22h3v3h-3zM5 14h1v13H5zM6 14h2v1H6z"/><path pid="2" d="M15 32H0V17h1v14h14zM32 32H17v-1h14V17h1zM32 15h-1V1H17V0h15zM1 15H0V0h15v1H1z"/>'
  }
})
